import { DownloadIcon, FileIcon } from "./icons";
import { fileNameFromUrl, fileSize } from "./time";

/** Renders a message attachment: an inline image (click → lightbox) or a
 *  download chip for files/PDFs. `sizeHint` is only known for a just-uploaded
 *  file (not persisted), so it's optional. */
export function Attachment({
  url,
  kind,
  onOpenImage,
  sizeHint,
  nameHint,
}: {
  url: string;
  kind: string | null;
  onOpenImage?: (url: string) => void;
  sizeHint?: number | null;
  nameHint?: string | null;
}) {
  if (kind === "image" || kind === "gif") {
    return (
      <button
        type="button"
        onClick={() => onOpenImage?.(url)}
        className="block mt-1 overflow-hidden rounded-xl border border-white/10 max-w-[240px] focus-visible:ring-2 focus-visible:ring-accent-500/40"
      >
        <img
          src={url}
          alt=""
          loading="lazy"
          className="max-h-72 w-auto object-cover bg-white/[0.03]"
        />
      </button>
    );
  }
  // file / document
  const name = nameHint || fileNameFromUrl(url);
  const sz = fileSize(sizeHint);
  return (
    <a
      href={url}
      download
      target="_blank"
      rel="noreferrer"
      className="mt-1 inline-flex items-center gap-2.5 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] px-3 py-2 max-w-[260px] transition"
    >
      <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-accent-500/15 text-accent-300">
        <FileIcon size={18} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[13px] text-slate-100">{name}</span>
        {sz && <span className="block text-[11px] text-slate-500">{sz}</span>}
      </span>
      <span className="text-slate-500">
        <DownloadIcon size={16} />
      </span>
    </a>
  );
}
